export const staticSearchData = [
    {
        keywords: " COVID-19 ,covide19,covid 19, covid, covid insurance",
        hits: 0,
        lang: "EN",
        description: "COVID-19",
        webUrl: "https://www.tawuniya.com/individuals/products/property_casualty/internationaltravel",
        mobileScreenName: "ALLPRODUCTS",
        category: "COVID-19",
        action: "Buy A policy",
        businessLine: "P&C",
    },
    {
        keywords: "كوفيد 19,كوفيد , تأمين كوفيد, تأمين كورونا ,كورونا",
        hits: 0,
        lang: "AR",
        description: "كوفيد-19",
        webUrl: "https://www.tawuniya.com/individuals/products/property_casualty/internationaltravel?lang=ar",
        mobileScreenName: "ALLPRODUCTS",
        category: " تأمين كوفيد",
        action: "اشتر وثيقتك الآن",
        businessLine: "الممتلكات والحوادث",
    },
    {
        keywords: "Home, Home insurance, House, House insurance, Property insurance, home  ",
        hits: 0,
        lang: "EN",
        description: "HomeInsurance",
        webUrl: "https://www.tawuniya.com/individuals/products/property_casualty/homeinsurance",
        mobileScreenName: "ALLPRODUCTS",
        category: " Home insurance ",
        action: "insure your property",
        businessLine: "P&C",
    },
    {
        keywords:
            "الممتلكات، ضد سرقة البيوت,تأمين المنازل,تأمين العقار,حريق المنزل,تأمين المساكن , تأمين البيوت, المساكن, تأمين بيت",
        hits: 0,
        lang: "AR",
        description: "HomeInsurance",
        webUrl: "https://www.tawuniya.com/individuals/products/property_casualty/homeinsurance?lang=ar",
        mobileScreenName: "ALLPRODUCTS",
        category: "تأمين المنازل",
        action: "أمن على ممتلكاتك",
        businessLine: "الممتلكات والحوادث",
    },
    {
        keywords:
            "medical malpractice, medical insurance, med mal, MMP, malpractice,Medical malpractice insurance, malpractice, malpractice insurance ",
        hits: 0,
        lang: "EN",
        description: "Medical malpractice insurance",
        webUrl: "https://www.tawuniya.com/individuals/products/property_casualty/medicalmalpractice",
        mobileScreenName: "ALLPRODUCTS",
        category: "Medical malpractice insurance",
        action: "Buy A Policy",
        businessLine: "P&C",
    },
    {
        keywords:
            "تأمين الممارسين الطبي، تأمين ممارسي المهن ، تأمين الأخطاء الطبية، تأمين المهن الطبية، تأمين سوء الممارسة،ضد الأخطاء المهنية، ضد الأخطاء الطبية، ضد الأخطاء، أخطاء المهن، تأمين المهن،تأمين المهن الطبية،تأمين الأخطاء الطبية،",
        hits: 0,
        lang: "AR",
        description: "تأمين أخطاء المهن الطبية",
        webUrl: "https://www.tawuniya.com/individuals/products/property_casualty/medicalmalpractice?lang=ar",
        mobileScreenName: "ALLPRODUCTS",
        category: "تأمين أخطاء ممارسة المهن الطبية",
        action: "اشتر وثيقتك",
        businessLine: "الممتلكات والحوادث",
    },
    {
        keywords:
            "Travel insurance, travel, flight delay insurance, schengen insurance, schengen insurance, world wide insurance, worldwide insurance, baggage loss insurance, flight cancelation, baggage loss",
        hits: 0,
        lang: "EN",
        description: "Travel insurance",
        webUrl: "https://www.tawuniya.com/individuals/products/property_casualty/internationaltravel",
        mobileScreenName: "ALLPRODUCTS",
        category: "Travel insurance",
        action: "Buy A Policy, For A Safe Travel ",
        businessLine: "P&C",
    },
    {
        keywords:
            "، الشنجن، تأمين الشنجن، تأمين السفر، سفر، السفر،تأمين, تأمين السفر،تأمين إلغاء الرحلة، تأمين فقدان الأمتعة، تأمين تأخر الحقائب، تأخر الرحلة، تأخير الرحلة",
        hits: 0,
        lang: "AR",
        description: "تأمين السفر",
        webUrl: "https://www.tawuniya.com/individuals/products/property_casualty/internationaltravel?lang=ar",
        mobileScreenName: "ALLPRODUCTS",
        category: "تأمين السفر",
        action: "اشتر وثيقتك, للسفر بأمان",
        businessLine: "الممتلكات والحوادث",
    },
    {
        keywords:
            "car insurance,motor insurance, vehicle insurance, car, motor, vehicle, comprehensive insurance, third party insurance, sanad, Third Partyplus, mbi, mechanical break down, gcc extension, gcc",
        hits: 0,
        lang: "EN",
        description: "MotorInsurance",
        webUrl: "https://www.tawuniya.com/individuals/products/motor",
        mobileScreenName: "ALLPRODUCTS",
        category: "Motor Insurance ",
        action: "Insure Your Motor",
        businessLine: "Motor",
    },
    {
        keywords:
            "عروض تأمين المركبات،سعر تأمين المركبات,مركبات، سيارات,مركبة,سيارة,تأمين سيارات,تأمين مركبات, تأمين سيارات, تأمين مركبات,  أسعار تأمين المركبات،تأمين شامل، تأمين ضد الغير، تأمين سند، تأمين سند بلس، سند، سند بلس، شامل،ضد الغير،اصدار تأمين مركبات",
        hits: 0,
        lang: "AR",
        description: "تأمين مركبات",
        webUrl: "https://www.tawuniya.com/individuals/products/motor?lang=ar",
        mobileScreenName: "ALLPRODUCTS",
        category: " تأمين مركبات ",
        action: "أمن على مركبتك",
        businessLine: "مركبة",
    },
    {
        keywords:
            "Drive, Driver Behavior, weekly rewards, Tawuniya drive, Drive safe, Tawuniya drive points  ",
        hits: 0,
        lang: "EN",
        description: "Drive",
        webUrl: "https://www.tawuniya.com/individuals/loyalty-program/drive",
        mobileScreenName: "ALLPRODUCTS",
        category: "Drive",
        action: "Activate Drive, and get rewarded",
        businessLine: "Motor",
    },
    {
        keywords:
            "درايف, سلوك السائق, مكافآت أسبوعية, تعاونية درايف, تطبيق درايف, التعاونية درايف, نقاط التعاونية درايف, ميزات السلامة",
        hits: 0,
        lang: "AR",
        description: "درايف",
        webUrl: "https://www.tawuniya.com/individuals/loyalty-program/drive?lang=ar",
        mobileScreenName: "ALLPRODUCTS",
        category: " درايف ",
        action: "فعل درايف، واحصل على مكافآت",
        businessLine: "مركبة",
    },
    {
        keywords:
            "visit insurance,visitors insurance, visit visa, visa extension, visit visa extension, visa, visitors, family visit, family visa, visit, extension, extension insurance",
        hits: 0,
        lang: "EN",
        description: "Visit Visa Insurance",
        webUrl: "https://www.tawuniya.com/individuals/products/health/visit-visa-insurance",
        mobileScreenName: "ALLPRODUCTS",
        category: "Visit Visa Insurance",
        action: "Buy A Policy",
        businessLine: "Medical",
    },
    {
        keywords:
            "تأمين التأشيرة، تأشيرة تمديد الزيارة، تمديد التأشيرة،تأمين زيارة،تأشيرة الزيارة،تأمين تأشيرة الزيارة، زيارة عائلية، فيزا، زيارة",
        hits: 0,
        lang: "AR",
        description: "تأمين تأشيرة الزيارة",
        webUrl: "https://www.tawuniya.com/individuals/products/health/visit-visa-insurance?lang=ar",
        mobileScreenName: "ALLPRODUCTS",
        category: "تأمين تأشيرة الزيارة",
        action: "اشتر وثيقتك",
        businessLine: "طبي",
    },
    {
        keywords:
            "health, medical, health sme,medical sme, medical 360, health insurance, medical insurance, health sme insurance, medical sme insurance, employees insurance",
        hits: 0,
        lang: "EN",
        description: "Medical SME Insurance",
        webUrl: "https://www.tawuniya.com/corporate/products/health/360-health-insurance",
        mobileScreenName: "ALLPRODUCTS",
        category: "Medical SME Insurance",
        action: "Insure Your Business",
        businessLine: "Medical",
    },
    {
        keywords:
            "تأمين المنشآت الطبي،  الطبي، تأمين صحي، تأمين طبي، تأمين طبي،تأمين صحي، تأمين الموظفين، صحي، طبي،تأمين المنشآت، تأمين الشركات الطبي",
        hits: 0,
        lang: "AR",
        description: "تأمين المنشآت الطبي",
        webUrl: "https://www.tawuniya.com/corporate/products/health/360-health-insurance?lang=ar",
        mobileScreenName: "ALLPRODUCTS",
        category: "تأمين المنشآت الطبي",
        action: "أمن أعمالك",
        businessLine: "طبي",
    },
    {
        keywords:
            "My family, healthcare, family Insurance, policy coverage, My family program, condition My family program",
        hits: 0,
        lang: "EN",
        description: "My family Health Insurance",
        webUrl: "https://www.tawuniya.com/individuals/products/health/myfamily-insurance",
        mobileScreenName: "ALLPRODUCTS",
        category: "My family Health Insurance",
        action: "Buy Your Policy Now",
        businessLine: "Medical",
    },
    {
        keywords:
            "عائلتي، رعاية صحية، تأمين عائلتي، برنامج عائلتي، عائلتي للتأمين الطبي، تغطيات تأمين عائلتي، شروط برنامج عائلتي",
        hits: 0,
        lang: "AR",
        description: "عائلتي",
        webUrl: "https://www.tawuniya.com/individuals/products/health/myfamily-insurance?lang=ar",
        mobileScreenName: "ALLPRODUCTS",
        category: "عائلتي",
        action: "اشتر وثيقتك الآن",
        businessLine: "طبي",
    },
    {
        keywords:
            "Hajj Insurance, Hajj And Umrah, Hajj medical, Hajj health insurance, Hajj for Foreighs",
        hits: 0,
        lang: "EN",
        description: "Hajj Insurance",
        webUrl: "https://www.tawuniya.com/individuals/products/health/hajj-insurance",
        mobileScreenName: "ALLPRODUCTS",
        category: "Hajj Insurance",
        action: "Buy A Policy",
        businessLine: "Medical",
    },
    {
        keywords:
            "تأمين الحج، لحجاج الخارج، برنامج التأمين للحج ،موسم الحج ، مزايا تأمين الحج،تأمين حجاج  ",
        hits: 0,
        lang: "AR",
        description: "تأمين الحج ",
        webUrl: "https://www.tawuniya.com/individuals/products/health/hajj-insurance?lang=ar",
        mobileScreenName: "ALLPRODUCTS",
        category: "تأمين الحج",
        action: "اشتر وثيقتك",
        businessLine: "طبي",
    },
    {
        keywords: "Umrah Insurance، Umrah coverage,Umrah insurance program,Forign Pilgrims ",
        hits: 0,
        lang: "EN",
        description: "Umrah Insurance",
        webUrl: "https://www.tawuniya.com/individuals/products/health/umrah-insurance",
        mobileScreenName: "ALLPRODUCTS",
        category: "Umrah Insurance",
        action: "Buy A policy",
        businessLine: "Medical",
    },
    {
        keywords:
            "، معتمري الخارج، تغطية تأمين العمرة، تأمين المعتمرين، تأمين العمرة،تغطيات العمرة، برنامج تأمين العمرة ",
        hits: 0,
        lang: "AR",
        description: "تأمين العمرة",
        webUrl: "https://www.tawuniya.com/individuals/products/health/umrah-insurance?lang=ar",
        mobileScreenName: "ALLPRODUCTS",
        category: "تأمين العمرة",
        action: " اشتر وثيقتك",
        businessLine: "طبي",
    },
    {
        keywords:
            "Tawuniya Vitality,Vitality group,healthy lifestyle, vitality benefits, vitality partners,vitality Rewards ",
        hits: 0,
        lang: "EN",
        description: "Tawuniya Vitality",
        webUrl: "https://www.tawuniya.com/individuals/loyalty-program/vitality/",
        mobileScreenName: "Tawuniya Vitality",
        category: "Tawuniya Vitality",
        action: "Do More, Get More",
        businessLine: "Medical",
    },
    {
        keywords:
            "فيتالتي،التعاونية فيتالتي، أسلوب حياة صحي،شركاء فيتالتي،مجموعة فيتالتي، فيتاليتي،برنامج فيتالتي، مزايا فيتالتي،",
        hits: 0,
        lang: "AR",
        description: " التعاونية فيتاليتي",
        webUrl: "https://www.tawuniya.com/individuals/loyalty-program/vitality?lang=ar",
        mobileScreenName: "Tawuniya Vitality",
        category: "التعاونية فيتاليتي",
        action: "تحرك أكثر،تكسب أكثر",
        businessLine: "طبي",
    },
    {
        keywords: "Contact us,customer service,call centre,help,assist,live chat",
        hits: 0,
        lang: "EN",
        description: "Contact Us",
        webUrl: "https://www.tawuniya.com/contactus",
        mobileScreenName: "Contact Us",
        category: "Contact Us",
        action: "Send Your Request",
        businessLine: "Global",
    },
    {
        keywords: "تواصل معنا،خدمة عملاء،مركز اتصال،محادثة مباشرة,مساعدة",
        hits: 0,
        lang: "AR",
        description: " التعاونية فيتاليتي",
        webUrl: "https://www.tawuniya.com/contactus?lang=ar",
        mobileScreenName: "Contact Us",
        category: "التعاونية فيتاليتي",
        action: "أرسل طلبك",
        businessLine: "عام",
    },
    {
        keywords:
            "report fraud, fraud, medical fraud, motor fraud, p&c fraud, insurance fraud, Act of fraud",
        hits: 0,
        lang: "EN",
        description: "Report frouds",
        webUrl: "https://www.tawuniya.com/individuals/customerservice/report-fraud",
        mobileScreenName: "Report fraud",
        category: "Report fraud",
        action: "Report A Fraud",
        businessLine: "Global",
    },
    {
        keywords:
            "إبلاغ, احتيال, احتيال الطبي, احتيال المركبات, احتيال الممتلكات،تبليغ احتيال،ابلاغ عن مخالفات، احتيال تأمين،فعل احتيالي،احتيال تأمينات ",
        hits: 0,
        lang: "AR",
        description: " إبلاغ عن احتيال",
        webUrl: "https://www.tawuniya.com/individuals/customerservice/report-fraud?lang=ar",
        mobileScreenName: "Report fraud",
        category: " إبلاغ عن احتيال",
        action: " إبلاغ عن احتيال",
        businessLine: "عام",
    },
    {
        keywords: "Investor relation, investors,Tawuniya Relations, ",
        hits: 0,
        lang: "EN",
        description: "Investor relation",
        webUrl: "https://www.tawuniya.com/investor",
        mobileScreenName: "Investor relation",
        category: "Investor relation",
        action: "Contact Us",
        businessLine: "Global",
    },
    {
        keywords: "علاقات المساهمين، علاقات المستثمرين، علاقات التعاونية، أنواع أعمال التأمين ",
        hits: 0,
        lang: "AR",
        Description: "علاقات المساهمين",
        webUrl: "https://www.tawuniya.com/investor?lang=ar",
        mobileScreenName: "Investor relation",
        category: " علاقات المساهمين",
        action: "تواصل معنا",
        businessLine: "عام",
    },
    {
        keywords:
            "Careers, Career, jobs,about tawuniya,life at tawuniya,join tawuniya,current vacancies, ",
        hits: 0,
        lang: "EN",
        description: "Careers",
        webUrl: "https://www.tawuniya.com/careers",
        mobileScreenName: "Careers",
        category: "Careers",
        action: "Join Us",
        businessLine: "Global",
    },
    {
        keywords:
            "الوظائف, التوظيف،شواغر حالية،الحياة في التعاونية،عن التعاونية،التسجيل للوظائف،انضم الينا ",
        hits: 0,
        lang: "AR",
        Description: "الوظائف",
        webUrl: "https://www.tawuniya.com/careers?lang=ar",
        mobileScreenName: "Careers",
        category: " الوظائف",
        action: "انضم الينا",
        businessLine: "عام",
    },
    {
        keywords: "taj.taj program,tawuniya taj,suit your needs,diverse services",
        hits: 0,
        lang: "EN",
        description: "Taj program",
        webUrl: "https://www.tawuniya.com/",
        mobileScreenName: "ALLPRODUCTS",
        category: "Taj program",
        action: "Request Service",
        businessLine: "Medical",
    },
    {
        keywords: "تاج، برنامج تاج،تاج التعاونية,رعاية صحية,تغطية احتياجاتك,خدمات شاملة،",
        hits: 0,
        lang: "AR",
        Description: "برنامج تاج",
        webUrl: "https://www.tawuniya.com/",
        mobileScreenName: "Taj program",
        category: "برنامج تاج",
        action: "اطلب الخدمة",
        businessLine: "طبي",
    },
    {
        keywords:
            "Home Child Vaccine,vaccinate by age,vaccine schedule,vaccinate your children, your child health,your child safety, child vaccinate service, vaccinate your child,",
        hits: 0,
        lang: "EN",
        description: "Home Child Vaccine",
        webUrl: "https://www.tawuniya.com/individuals/customerservice/home-child-vaccination",
        mobileScreenName: "Home Child Vaccine",
        category: "Home Child Vaccine",
        action: "Request Service",
        businessLine: "Medical",
    },
    {
        keywords:
            "التطعيمات المنزلية للأطفال،تطعيم أولادك،تطعيم طفلك، صحة أطفالك،جدول التطعيمات،طفلك في أمان،خدمة التطعيمات للأطفال،",
        hits: 0,
        lang: "AR",
        description: "التطعيمات المنزلية للأطفال",
        webUrl: "https://www.tawuniya.com/individuals/customerservice/home-child-vaccination?lang=ar",
        mobileScreenName: "Home Child Vaccine",
        category: "التطعيمات المنزلية للأطفال",
        action: "اطلب الخدمة",
        businessLine: "طبي",
    },
    {
        keywords:
            "Chronic disease management,medical consultation,refill medications,chronic disease,laboratory services,",
        hits: 0,
        lang: "EN",
        description: "Chronic disease management",
        webUrl: "https://www.tawuniya.com/individuals/customerservice/chronic-disease-management",
        mobileScreenName: "Chronic disease management",
        category: "Chronic disease management",
        action: "Request Service",
        businessLine: "Medical",
    },
    {
        keywords:
            "، رعاية صحية، خدمات المختبر،صحتك،إعادة صرف الدواء، استشارة طبية،مرض مزمن،تحاليل مخبرية،إدارة الأمراض المزمنة",
        hits: 0,
        lang: "AR",
        description: "إدارة الأمراض المزمنة",
        webUrl: "https://www.tawuniya.com/individuals/customerservice/chronic-disease-management?lang=ar",
        mobileScreenName: "Chronic disease management",
        category: "إدارة الأمراض المزمنة",
        action: "اطلب الخدمة",
        businessLine: "طبي",
    },
    // {
    //   keywords:
    //     "Pregnancy follow-up program,pregnancy journey, pregnancy member,pregnant program,birth,pregnant women ",
    //   hits: 0,
    //   lang: "EN",
    //   description: "Pregnancy follow-up program",
    //   webUrl: "https://www.tawuniya.com/individuals/customerservice/pregnancy-follow-up-program",
    //   mobileScreenName: "Pregnancy follow-up program",
    //   category: "Pregnancy follow-up program",
    //   action: "Request Service",
    //   businessLine: "Medical",
    // },
    // {
    //   keywords:
    //     "حوامل،مراحل حملك،حالات الحمل،العضوة الحامل،توعوية للحامل،ولادة،برنامج حتى الولادة،متابعة الحمل التعاونية،برنامج متابعة الحمل",
    //   hits: 0,
    //   lang: "AR",
    //   description: "برنامج متابعة الحمل",
    //   webUrl: "https://www.tawuniya.com/individuals/customerservice/pregnancy-follow-up-program?lang=ar",
    //   mobileScreenName: "Pregnancy follow-up program",
    //   category: "برنامج متابعة الحمل",
    //   action: "اطلب الخدمة",
    //   businessLine: "طبي",
    // },
    {
        keywords: "Reﬁll Medication,dawae,refilling medicines,chronic diseases,",
        hits: 0,
        lang: "EN",
        description: "Reﬁll Medication",
        webUrl: "https://www.tawuniya.com/login",
        mobileScreenName: "Reﬁll Medication",
        category: "Reﬁll Medication",
        action: "Request A Refill",
        businessLine: "Medical",
    },
    {
        keywords: " ،,اصرف دوائك،مرض مزمن،دوائي،مراجعة الطبيب،إعادة صرف أدوية الأمراض المزمنة",
        hits: 0,
        lang: "AR",
        description: "إعادة صرف أدوية الأمراض المزمنة",
        webUrl: "https://www.tawuniya.com/login",
        mobileScreenName: "Reﬁll Medication",
        category: "إعادة صرف أدوية الأمراض المزمنة",
        action: "اطلب إعادة صرف",
        businessLine: "طبي",
    },
    {
        keywords:
            "Telemedicine,online consultation,consultation service,book an appointment online,accredited doctors ",
        hits: 0,
        lang: "EN",
        description: "Telemedicine",
        webUrl: "https://www.tawuniya.com/",
        mobileScreenName: "ALLPRODUCTS",
        category: "Telemedicine",
        action: "Request A Consultation",
        businessLine: "Medical",
    },
    {
        keywords:
            "استشر طبيبك،استشارة موثوقة، استشارة أونلاين،أطباء معتمدين،استشارة طبية،حجز موعد أونلاين، ",
        hits: 0,
        lang: "AR",
        description: "استشر طبيبك",
        webUrl: "https://www.tawuniya.com/",
        mobileScreenName: "Telemedicine",
        category: "استشر طبيبك",
        action: "اطلب استشارة طبية",
        businessLine: "طبي",
    },
    {
        keywords: "Assist America,Medical emergency, support outside Saudi,medical insurance,assist,",
        hits: 0,
        lang: "EN",
        description: "Assist America",
        webUrl: "https://www.tawuniya.com/",
        mobileScreenName: "ALLPRODUCTS",
        category: "Assist America",
        action: "Request The Service",
        businessLine: "Medical",
    },
    {
        keywords: "، اسست،خدمات خارج المملكة، طارئ طبي، الشريك الدولي،أسست أمريكا",
        hits: 0,
        lang: "AR",
        description: "أسست أمريكا",
        webUrl: "https://www.tawuniya.com/",
        mobileScreenName: "Assist America",
        category: "أسست أمريكا",
        action: "اطلب الخدمة",
        businessLine: "طبي",
    },
    {
        keywords:
            "Medical Reimbursement,reimburse your expenses,apply for reimbursement, tawuniya claims, claim",
        hits: 0,
        lang: "EN",
        description: "Medical Reimbursement",
        webUrl: "https://www.tawuniya.com/",
        mobileScreenName: "Medical Reimbursement",
        category: "Medical Reimbursement",
        action: "Request Service",
        businessLine: "Medical",
    },
    {
        keywords:
            "استعاضة المصروفات الطبية، استرداد مصروفاتك الطبية، استرداد الكتروني تسوية الطلبات بالتعاونية،خدمات التعاونية",
        hits: 0,
        lang: "AR",
        description: "استعاضة المصروفات الطبية",
        webUrl: "https://www.tawuniya.com/",
        mobileScreenName: "Medical Reimbursement",
        category: "استعاضة المصروفات الطبية",
        action: "استعاضة المصروفات الطبية",
        businessLine: "طبي",
    },
    {
        keywords: "Eligibility Letter",
        hits: 0,
        lang: "EN",
        description:
            "Eligibility Letter,immediate eligibility letter,request eligibility letter,link to eligibility letter",
        webUrl: "https://www.tawuniya.com/",
        mobileScreenName: "Eligibility Letter",
        category: "Eligibility Letter",
        action: "Request Service",
        businessLine: "Medical",
    },
    {
        keywords:
            "، الحصول على علاج،خطاب أهلية فوري، تأكيد الأهلية،طلب خطاب أهلية،حصول على خطاب أهلية، رابط خطاب الأهلية،خطاب الأهلية",
        hits: 0,
        lang: "AR",
        description: "خطاب الأهلية",
        webUrl: "https://www.tawuniya.com/",
        mobileScreenName: "Eligibility Letter",
        category: "خطاب الأهلية",
        action: "اطلب خطاب الأهلية",
        businessLine: "طبي",
    },
    {
        keywords:
            "claims, motor claim,individual claims, claim,alshamel motor claim,Third Partymotor claim,report motor claim,tawuniya claim,track your claim,claims tracking,motor claims details,motor claims submission",
        hits: 0,
        lang: "EN",
        description: "Submit Claim",
        webUrl: "https://www.tawuniya.com/product/tp-claims",
        mobileScreenName: "Submit Claim",
        category: "Submit Claim",
        action: "Submit Your Claims",
        businessLine: "Motor",
    },
    {
        keywords:
            "،مطالبات، تعويضات،تعويض عملاء الشامل،مطالبات تعويض المركبات،الحد الأقصى لتعويض المركبات،قيمة التعويض،مطالبات المركبات،تقديم مطالبة",
        hits: 0,
        lang: "AR",
        Description: "تقديم مطالبة",
        webUrl: "https://www.tawuniya.com/product/tp-claims?lang=ar",
        mobileScreenName: "Submit Claim",
        category: "تقديم مطالبة",
        action: "قدم مطالباتك",
        businessLine: "مركبة",
    },
    {
        keywords:
            "claims,claim details,motor insurance claims track,Tawuniya claims,claim tracking,online claim,third party claim,track your claim,",
        hits: 0,
        lang: "EN",
        description: "Track Claim",
        webUrl: "https://www.tawuniya.com/product/tp-claims",
        mobileScreenName: "Track Claim",
        category: "Track Claim",
        action: "Track Your Claims",
        businessLine: "Motor",
    },
    {
        keywords:
            "متابعة المطالبات،تتبع مطالبة،مطالبة غير مكتملة،نموذج مطالبة،تسليم مطالبة،مطالبة،مطالبة طرف ثالث،فاصيل المطالبة،",
        hits: 0,
        lang: "AR",
        description: "متابعة المطالبات",
        webUrl: "https://www.tawuniya.com/product/tp-claims?lang=ar",
        mobileScreenName: "Track Claim",
        category: "متابعة المطالبات",
        action: "تابع مطالباتك",
        businessLine: "مركبة",
    },
    {
        keywords:
            "ithra,ithraa partners,ithraa program,ithraa,ithra discounts,ithra beneficiary,ithra benefits,ithra Tawuniya",
        hits: 0,
        lang: "EN",
        description: "Ithra",
        webUrl: "https://www.tawuniya.com/individuals/loyalty-program/ithra",
        mobileScreenName: "Ithra",
        category: "Ithra",
        action: "Start Here",
        businessLine: "ALL",
    },
    {
        keywords:
            "إثراء،عروض إثراء،شركاء إثراء،مستفيدي إثراء،خصومات إثراء،برنامج إثراء،مدة برنامج إثراء،تثري حياتك،تثري،مزايا إثراء،",
        hits: 0,
        lang: "AR",
        description: "إثراء",
        webUrl: "https://www.tawuniya.com/individuals/loyalty-program/ithra?lang=ar",
        mobileScreenName: "IthraPrime",
        category: "إثراء",
        action: "إثراء",
        businessLine: "الجميع",
    },
    {
        keywords: "ithra prime",
        hits: 0,
        lang: "EN",
        description: "Ithra Prime",
        webUrl: "https://www.tawuniya.com/individuals/loyalty-program/ithra",
        mobileScreenName: "IthraPrime",
        category: "Ithra Ithra Prime",
        action: "Get Started",
        businessLine: "motor",
    },
    {
        keywords: "إثراء برايم",
        hits: 0,
        lang: "AR",
        description: "إثراء برايم",
        webUrl: "https://www.tawuniya.com/individuals/loyalty-program/ithra?lang=ar",
        mobileScreenName: "IthraPrime",
        category: "إثراء برايم",
        action: "إبدأ",
        businessLine: "مركبة",
    },
    {
        keywords:
            "Road assistance, battery charge,change battery emergency,fuel supply,tire change, tawuniya service",
        hits: 0,
        lang: "EN",
        description: "Roadside assistance",
        webUrl: "https://www.tawuniya.com/individuals/customerservice/road-assistance",
        mobileScreenName: "Roadside assistance",
        category: "Roadside assistance",
        action: "Submit a request",
        businessLine: "Motor",
    },
    {
        keywords:
            "،مساعدة الطريق،تغير البطارية،مساعدة طارئة، خدمات التعاونية، تغير إطار المركبة،خدمة بنزين",
        hits: 0,
        lang: "AR",
        Description: "مساعدة الطريق",
        webUrl: "https://www.tawuniya.com/individuals/customerservice/road-assistance?lang=ar",
        mobileScreenName: "Roadside assistance",
        category: "مساعدة الطريق",
        action: "اطلب الخدمة",
        businessLine: "مركبة",
    },
    {
        keywords:
            "Motor vehicle periodic inspection, free charge of transferring, inspecting your vehicle,vehicles services, tawuniya MVPI,inspection report",
        hits: 0,
        lang: "EN",
        description: "Motor vehicle periodic inspection",
        webUrl: "https://www.tawuniya.com/individuals/products/motor",
        mobileScreenName: "MVPI",
        category: "Motor vehicle periodic inspection",
        action: "submit a request",
        businessLine: "Motor",
    },
    {
        keywords:
            " خدمة الفحص الدوري، فحص المركبات، خدمة فحص مركبتك،خدمات التعاونية،فحص المركبة،تقرير الفحص ",
        hits: 0,
        lang: "AR",
        Description: "خدمة الفحص الدوري",
        webUrl: "https://www.tawuniya.com/individuals/products/motor?lang=ar",
        mobileScreenName: "MVPI",
        category: "خدمة الفحص الدوري",
        action: "اطلب الخدمة",
        businessLine: "مركبة",
    },
    {
        keywords:
            "Balsam, tawuniya balsam,balsam cooperative health insurance,balsam gold,balsam direct,balsam benefits,balsam exclusive, balsam program,",
        hits: 0,
        lang: "EN",
        description: "Balsam",
        webUrl: "https://www.tawuniya.com/corporate/products/health/balsam",
        mobileScreenName: "ALLPRODUCTS",
        category: "Balsam",
        action: "Insure Your Business",
        businessLine: "Medical",
    },
    {
        keywords:
            ",بلسم،بلسم مباشر، بلسم الذهبي،بلسم للتأمين الطبي،برنامج بلسم،فئات برنامج بلسم،تغطيات بلسم،مزايا بلسم، شروط برنامج بلسم،خدمات بلسم،امتيازات بلسم",
        hits: 0,
        lang: "AR",
        description: "بلسم",
        webUrl: "https://www.tawuniya.com/corporate/products/health/balsam?lang=ar",
        mobileScreenName: "ALLPRODUCTS",
        category: "بلسم",
        action: "أمن أعمالك",
        businessLine: "طبي",
    },
    {
        keywords:
            "takaful, group life insurance, takaful insurance,Takaful insurance,benefit of takaful insurance,takaful insurance",
        hits: 0,
        lang: "EN",
        description: "Takaful",
        webUrl: "https://www.tawuniya.com/corporate/products/health/takaful",
        mobileScreenName: "ALLPRODUCTS",
        category: "Takaful",
        action: "Buy Apolicy",
        businessLine: "Medical",
    },
    {
        keywords: "تكافل,منافع برنامج تكافل،تغطية برنامج تكافل،التكافل الجماعي،منافع إضافية",
        hits: 0,
        lang: "AR",
        description: "تكافل",
        webUrl: "https://www.tawuniya.com/corporate/products/health/takaful?lang=ar",
        mobileScreenName: "ALLPRODUCTS",
        category: "تكافل",
        action: "اشتر وثيقتك",
        businessLine: "طبي",
    },
];